<template>
	<div class="new-chip-info" :class="{ 'new-chip-info-ac': ac }">
		<header-component
			:is-soon="false"
			img-left="/trocachip/img/setinha-left-preto.svg"
			img-right="/trocachip/img/access.svg"
			class="header-component"
		/>
		<!-- body -->
		<div class="new-chip-info_body">
			<div class="mobile-container">
				<h2 class="new-chip-info_title">
					Para trocar o seu chip informe os seus dados
				</h2>
				<p class="new-chip-info_subtitle" v-show="!isExOi()">
					Para os próximos passos você vai precisar ter em mãos o seu novo chip
					4G.
				</p>
				<!-- form -->
				<div class="new-chip-info_form">
					<div class="new-chip-info_form_fieldset">
						<section class="text-input" :class="{ 'text-input--ac': ac }">
							<p class="text-input__label">CPF</p>
							<input
								v-model="documentNumberInputValue"
								class="text-input__input"
								:class="{ 'ac-input': ac }"
								type="text"
								placeholder="000.000.000-00"
								v-mask="'###.###.###-##'"
								@blur="onChangeDocumentNumberInput()"
								@keydown="clearDocumentNumberInputError()"
								@input="$emit('input', $event.target.value)"
								@change="$emit('change', $event)"
							/>
							<p
								v-if="documentNumberInputErrorMessage"
								class="text-input__message"
							>
								{{ documentNumberInputErrorMessage }}
							</p>
						</section>
					</div>
					<div class="new-chip-info_form_fieldset">
						<section class="text-input" :class="{ 'text-input--ac': ac }">
							<p class="text-input__label">DDD + Número da TIM</p>
							<input
								v-model="phoneNumberInputValue"
								class="text-input__input"
								:class="{ 'ac-input': ac }"
								type="text"
								placeholder="(00) 00000-0000"
								v-mask="phoneNumberInputMask"
								@blur="onChangePhoneNumberInput()"
								@keydown="clearPhoneNumberInputError()"
								@input="$emit('input', $event.target.value)"
								@change="$emit('change', $event)"
							/>
							<p
								v-if="phoneNumberInputErrorMessage"
								class="text-input__message"
							>
								{{ phoneNumberInputErrorMessage }}
							</p>
						</section>
					</div>
				</div>
				<!-- end form -->
			</div>
		</div>
		<div
			:class="{ 'background-desktop-black': ac, 'background-desktop': !ac }"
		></div>
		<!-- end body -->
		<!-- footer -->
		<div class="new-chip-info_footer">
			<div class="mobile-container">
				<div class="new-chip-info_footer_button">
					<action-button
						theme="dark_full"
						@click="onClickAdvance"
						:disabled="AdvanceButtonDisabled"
						>Continuar</action-button
					>
				</div>
			</div>
		</div>
		<!-- end footer -->
		<!-- error alert -->
		<alert
			:danger="true"
			:description="alertDescription"
			:message="alertMessage"
			@close="onCloseErrorAlert"
			v-if="alertActive"
		/>
		<!-- end error alert -->
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Auth from '@/core/auth';
import ActionButton from '@/components/ActionButton';
import Alert from '../components/Alert';
import HeaderComponent from '@/components/HeaderComponent';
import AuthService from '@/services/auth';
import trackEvent from '@/services/trackEvent';
import ValidatorUtil from '@/utils/validator';

export default {
	components: {
		ActionButton,
		Alert,
		HeaderComponent,
	},
	data() {
		return {
			PHONE_NUMBER_DEFAULT_MASK: '(##) ####-####?#',
			PHONE_NUMBER_NEW_MASK: '(##) #####-####',
			documentNumberInputValue: '',
			documentNumberInputFilled: false,
			documentNumberInputError: false,
			documentNumberInputOk: false,
			documentNumberInputErrorMessage: '',
			phoneNumberInputValue: '',
			phoneNumberInputFilled: false,
			phoneNumberInputError: false,
			phoneNumberInputErrorMessage: '',
			phoneNumberInputOk: false,
			phoneNumberInputMask: '(##) ####-####?#',
			submitting: false,
			alertDescription: '',
			alertMessage: '',
			alertActive: false,
		};
	},
	computed: {
		rawDocumentNumberInputValue() {
			return this.documentNumberInputValue.replace(/[.-]/g, '');
		},
		rawPhoneNumberInputValue() {
			return this.phoneNumberInputValue.replace(/[^\d]/g, '');
		},
		...mapState({
			ac: (state) => state.ac,
			customer: (state) => state.customer,
			document: (state) => state.document,
			phoneNumber: (state) => state.phoneNumber,
		}),
		AdvanceButtonDisabled() {
			return (
				this.submitting ||
				!this.documentNumberInputOk ||
				!this.phoneNumberInputOk
			);
		},
	},
	watch: {
		documentNumberInputValue() {
			if (this.documentNumberInputValue.length === 14) {
				this.onChangeDocumentNumberInput();
			}
		},
		phoneNumberInputValue() {
			if (this.phoneNumberInputValue.length >= 14) {
				this.onChangePhoneNumberInput();
			}
		},
	},
	methods: {
		reauthenticate() {
			Auth.reinit();
		},
		updatePhoneNumberInputMask() {
			if (
				this.phoneNumberInputValue.length === 15 &&
				this.phoneNumberInputMask !== this.PHONE_NUMBER_NEW_MASK
			) {
				this.phoneNumberInputMask = this.PHONE_NUMBER_NEW_MASK;
			} else if (
				this.phoneNumberInputValue.length < 15 &&
				this.phoneNumberInputMask !== this.PHONE_NUMBER_DEFAULT_MASK
			) {
				this.phoneNumberInputMask = this.PHONE_NUMBER_DEFAULT_MASK;
			}
		},
		restoreDataFromStore() {
			this.documentNumberInputValue = this.document;
			this.phoneNumberInputValue = this.phoneNumber;
		},
		saveDataToStore() {
			this.$store.dispatch('document', this.rawDocumentNumberInputValue);
			this.$store.dispatch('phoneNumber', this.rawPhoneNumberInputValue);
		},
		advance() {
			return this.$router.push({ name: 'protocol' });
		},
		validate() {
			return AuthService.check(
				this.rawPhoneNumberInputValue,
				this.rawDocumentNumberInputValue
			);
		},
		async submit() {
			this.submitting = true;

			this.validate()
				.then(async (response) => {
					if (response.data.internalCode == '1') {
						await this.saveDataToStore();
						await this.reauthenticate();
						await this.trackAdvanceSuccess();
						return this.$router.push({ name: 'protocol' });
					} else {
						return this.handleValidateError(response.data);
					}
				})
				.catch((err) => {
					return this.handleValidateError(err.response.data);
				});
		},
		showAlert(description, message) {
			this.alertDescription = description;
			this.alertMessage = message;
			this.alertActive = true;
		},
		hideAlert() {
			this.alertDescription = '';
			this.alertMessage = '';
			this.alertActive = false;
		},
		handleValidateError(data) {
			this.submitting = false;
			this.showAlert(data['DESC_ERRO'], data['MSG_ERRO']);
			this.trackAdvanceFail(data);
		},
		onCloseErrorAlert() {
			this.hideAlert();
		},
		clearDocumentNumberInputError() {
			this.documentNumberInputError = false;
			this.documentNumberInputErrorMessage = '';
		},
		clearPhoneNumberInputError() {
			this.phoneNumberInputError = false;
			this.phoneNumberInputErrorMessage = '';
		},
		validateDocumentoNumberInput() {
			const value = this.rawDocumentNumberInputValue;

			this.documentNumberInputOk = false;
			this.documentNumberInputError = false;
			this.documentNumberInputErrorMessage = '';

			if (value.length === 0) {
				this.documentNumberInputError = true;
				this.documentNumberInputErrorMessage = 'O número de CPF é obrigatório';
			} else if (value.length < 11) {
				this.documentNumberInputError = true;
				this.documentNumberInputErrorMessage =
					'O número de CPF está incompleto';
			} else if (!ValidatorUtil.cpf(value)) {
				this.documentNumberInputError = true;
				this.documentNumberInputErrorMessage = 'Número de CPF inválido';
			} else {
				this.documentNumberInputOk = true;
			}

			return this.documentNumberInputOk;
		},
		validatePhoneNumberInput() {
			const value = this.phoneNumberInputValue;

			this.phoneNumberInputOk = false;
			this.phoneNumberInputError = false;
			this.phoneNumberInputErrorMessage = '';

			if (value.length === 0) {
				this.phoneNumberInputError = true;
				this.phoneNumberInputErrorMessage = 'O número TIM é obrigatório';
			} else if (value.length < 14) {
				this.phoneNumberInputError = true;
				this.phoneNumberInputErrorMessage = 'O número TIM está incompleto';
			} else {
				this.phoneNumberInputOk = true;
			}

			return this.phoneNumberInputOk;
		},
		trackAdvanceSuccess() {
			if (this.isExOi()) {
				trackEvent.track({
					user: {
						login: this.customer.login,
						loginType: this.customer.loginType,
						lineType: this.customer.lineType,
						segment: this.customer.segment,
						subSegment: this.customer.subSegment,
						planCode: this.customer.planCode,
						planName: this.customer.planName,
					},
					channel: trackEvent.getChannel(),
					'event-category': 6,
					'event-label': 'Troca de Chip Cliente Oi Dados',
					'event-value': null,
					'event-status': 'Sucesso',
					'event-interactionNumber': '',
					'event-error': '',
					'event-errorDetail': '',
				});
			} else {
				trackEvent.track({
					user: {
						login: this.customer.login,
						loginType: this.customer.loginType,
						lineType: this.customer.lineType,
						segment: this.customer.segment,
						subSegment: this.customer.subSegment,
						planCode: this.customer.planCode,
						planName: this.customer.planName,
					},
					channel: trackEvent.getChannel(),
					'event-category': 6,
					'event-label': 'Perda Roubo Defeito CPF',
					'event-value': null,
					'event-status': 'Sucesso',
					'event-interactionNumber': '',
					'event-error': '',
					'event-errorDetail': '',
				});
			}
		},
		trackAdvanceFail(responseError) {
			if (this.isExOi()) {
				trackEvent.track({
					user: {
						login: this.customer.login,
						loginType: this.customer.loginType,
						lineType: this.customer.lineType,
						segment: this.customer.segment,
						subSegment: this.customer.subSegment,
						planCode: this.customer.planCode,
						planName: this.customer.planName,
					},
					channel: trackEvent.getChannel(),
					'event-category': 6,
					'event-label': 'Troca de Chip Cliente Oi Dados',
					'event-value': null,
					'event-status': 'Falha',
					'event-interactionNumber': '',
					'event-error': responseError.desc,
					'event-errorDetail': responseError.message,
				});
			} else {
				trackEvent.track({
					user: {
						login: this.customer.login,
						loginType: this.customer.loginType,
						lineType: this.customer.lineType,
						segment: this.customer.segment,
						subSegment: this.customer.subSegment,
						planCode: this.customer.planCode,
						planName: this.customer.planName,
					},
					channel: trackEvent.getChannel(),
					'event-category': 6,
					'event-label': 'Perda Roubo Defeito CPF',
					'event-value': null,
					'event-status': 'Falha',
					'event-interactionNumber': '',
					'event-error': responseError.desc,
					'event-errorDetail': responseError.message,
				});
			}
		},
		onClickAdvance() {
			this.submit();
		},
		onChangePhoneNumberInput() {
			this.updatePhoneNumberInputMask();

			if (!this.phoneNumberInputFilled) {
				this.phoneNumberInputFilled = true;
			}

			if (this.phoneNumberInputError) {
				this.clearPhoneNumberInputError();
			}

			this.validatePhoneNumberInput();
		},
		onChangeDocumentNumberInput() {
			if (!this.documentNumberInputFilled) {
				this.documentNumberInputFilled = true;
			}

			if (this.documentNumberInputError) {
				this.clearDocumentNumberInputError();
			}

			this.validateDocumentoNumberInput();
		},
		isExOi() {
			return this.customer.isExOiCustomer;
		},
	},
	created() {
		this.restoreDataFromStore();
	},
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/mixins';

.new-chip-info {
	display: flex;
	flex-direction: column;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	min-height: 100%;
	padding-top: 96px;
	box-sizing: border-box;
	background-color: #ffffff;
}

.new-chip-info-ac.new-chip-info {
	background-color: #1c1c1c;
}

.new-chip-info_body {
	flex: 1;
}

.new-chip-info_title {
	display: block;
	margin: 0;
	padding: 0;
	color: #181818;
	text-align: center;
	font-family: timsans_thin;
	font-size: 1.75rem;
	line-height: normal;
}

.new-chip-info-ac .new-chip-info_title {
	color: #ffffff;
}

.new-chip-info_subtitle {
	display: block;
	margin: 20px 0 0 0;
	padding: 0 10%;
	color: #808080;
	text-align: center;
	font-family: timsans_regular;
	font-size: 0.9375rem;
	line-height: normal;
}

.new-chip-info-ac .new-chip-info_subtitle {
	color: #ffffff;
}

.new-chip-info_form {
	margin-top: 40px;
}

.new-chip-info_form_fieldset {
	margin-top: 30px;

	&:first-child {
		margin-top: 0px;
	}
}

.new-chip-info_footer {
	padding-top: 40px;
	padding-bottom: 40px;
}

.new-chip-info_footer_button {
}

@media all and (max-width: 359px) {
	.new-chip-info_subtitle {
		padding: 0 6%;
	}
}

@media (min-width: 768px) {
	.new-chip-info {
		display: grid;
		grid-auto-columns: 50% 50%;
		grid-template-areas:
			'header header'
			'body background'
			'footer background';
		position: absolute;
		padding-top: 0;
	}

	.header-component {
		width: 45%;
		grid-area: header;
	}

	.new-chip-info-ac.new-chip-info {
		background-color: #1c1c1c;
	}

	.new-chip-info_body {
		grid-area: body;
		margin-top: 139px;
	}

	.background-desktop {
		grid-area: background;
		width: 100%;
		height: 100vh;
		flex: 1;
		background: url('../assets/images/desktop@3x.png') no-repeat;
		background-size: 240% 100vh;
		background-position-x: -20px;
	}

	.background-desktop-black {
		grid-area: background;
		width: 100%;
		height: 100vh;
		display: block;
		background: url('../assets/images/desktop-black.png') no-repeat;
		background-size: 240% 100vh;
		background-position-x: -20px;
	}

	.mobile-container {
		width: 90%;
	}

	.new-chip-info_title {
		width: 90%;
		display: block;
		margin: 0;
		padding: 0;
		color: #181818;
		text-align: center;
		font-family: timsans_thin;
		font-weight: 300;
		font-size: 2rem;
		line-height: normal;
	}

	.new-chip-info-ac .new-chip-info_title {
		color: #ffffff;
	}

	.new-chip-info_subtitle {
		width: 90%;
		display: block;
		margin: 24px auto 0 auto;
		padding: 0;
		color: #808080;
		text-align: center;
		font-family: timsans_regular;
		font-size: 1em;
		line-height: normal;
	}

	.new-chip-info-ac .new-chip-info_subtitle {
		color: #ffffff;
	}

	.new-chip-info_form {
		width: 100%;
		margin-top: 40px;
	}

	.new-chip-info_form_fieldset {
		margin-top: 30px;

		&:first-child {
			margin-top: 0px;
		}
	}

	.new-chip-info_footer {
		width: 100%;
		grid-area: footer;
		padding-top: 40px;
		padding-bottom: 40px;
	}

	.new-chip-info_footer_button {
	}
}
@media (min-width: 960px) {
	.new-chip-info {
		display: grid;
		grid-auto-columns: 50% 50%;
		grid-template-areas:
			'header header'
			'body background'
			'footer background';
		position: absolute;
		padding-top: 0;
	}

	.header-component {
		width: 45%;
		grid-area: header;
	}

	.new-chip-info-ac.new-chip-info {
		background-color: #1c1c1c;
	}

	.new-chip-info_body {
		grid-area: body;
		margin-top: 139px;
	}

	.background-desktop {
		grid-area: background;
		width: 100%;
		height: 100vh;
		flex: 1;
		background: url('../assets/images/desktop@3x.png') no-repeat;
		background-size: cover;
		background-position-x: 0;
	}

	.background-desktop-black {
		grid-area: background;
		width: 100%;
		height: 100vh;
		display: block;
		background: url('../assets/images/desktop-black.png') no-repeat;
		background-size: cover;
		background-position-x: 0;
	}

	.mobile-container {
		width: 400px;
		max-width: 400px;
	}

	.new-chip-info_title {
		width: 400px;
		display: block;
		margin: 0;
		padding: 0;
		color: #181818;
		text-align: center;
		font-family: timsans_thin;
		font-weight: 300;
		font-size: 2rem;
		line-height: normal;
	}

	.new-chip-info-ac .new-chip-info_title {
		color: #ffffff;
	}

	.new-chip-info_subtitle {
		width: 400px;
		display: block;
		margin: 24px auto 0 auto;
		padding: 0;
		color: #808080;
		text-align: center;
		font-family: timsans_regular;
		font-size: 1em;
		line-height: normal;
	}

	.new-chip-info-ac .new-chip-info_subtitle {
		color: #ffffff;
	}

	.new-chip-info_form {
		width: 400px;
		margin-top: 40px;
	}

	.new-chip-info_form_fieldset {
		margin-top: 30px;

		&:first-child {
			margin-top: 0px;
		}
	}

	.new-chip-info_footer {
		width: 100%;
		grid-area: footer;
		padding-top: 40px;
		padding-bottom: 40px;
	}

	.new-chip-info_footer_button {
	}
}

.text-input__label {
	display: block;
	margin: 0;
	padding: 0;
	color: #808080;
	font-family: timsans_regular;
	font-size: 0.8125rem;
	line-height: normal;
	text-transform: uppercase;
}

.text-input--ac .text-input__label {
	color: #ffffff;
}

.text-input--ac .text-input__input {
	@include placeholdercolor(#ffffff);
	color: #ffffff;
}

.text-input__message {
	display: block;
	color: red;
	margin: 12px 0;
	padding: 0;
	font-size: 0.75em;
	font-family: 'timsans_regular';
}

.text-input--ac .text-input__message {
	color: #ffff00;
}
</style>
